import axios from "axios";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export default function () {

  const Home = document.querySelector('#locations-content'); 
  if (!Home) return;
  console.log('Page Location');

  const swiperNyAcademy = new Swiper(".swiper-ny-academy", {
    slidesPerView: 'auto',
    centeredSlides:true,
    spaceBetween: 20,
    loop:true,
    navigation: { nextEl: ".swiper-button-ny-next", prevEl: ".swiper-button-ny-prev" },
    breakpoints: { 600:{ spaceBetween:32 } },
    on: {
      slideChange: function () {
        const activeSlide = this.slides[this.activeIndex];
        const allSlides = document.querySelectorAll('.swiper-ny-academy .swiper-slide .bg-slides-gray');
        allSlides.forEach(i=> i.classList.add('activate'));
        const bg = activeSlide?.querySelector('.bg-slides-gray');
        bg?.classList.remove('activate');
      },
    }
  });

  function updateSlideCounter(swiperInstance) {
    const current = swiperInstance.realIndex + 1;
    const total = swiperInstance.slides.length - (swiperInstance.loopedSlides * 2 || 0) || swiperInstance.slides.length;
    const el = document.getElementById("slide-counter");
    if (el) el.innerHTML = `<span class='text-white'>${current}</span><span class='text-white/40'>/${total}</span>`;
  }

  function markActiveInstructor(swiper) {
    swiper.slides.forEach(slide => slide.classList.remove('is-active'));
    const active = swiper.slides[swiper.activeIndex];
    if (active) active.classList.add('is-active');
  }

  const swiperNyInstrutores = new Swiper(".swiper-ny-instrutores", {
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides:true,
    navigation: { nextEl: ".swiper-button-instrutores-ny-next", prevEl: ".swiper-button-instrutores-ny-prev" },
    breakpoints: { 0:{ spaceBetween:12 }, 1024:{ spaceBetween:0 } },
    on:{
      init() { updateSlideCounter(this); markActiveInstructor(this); },
      slideChange() { updateSlideCounter(this); markActiveInstructor(this); }
    }
  });

  const btns = document.querySelectorAll(".button-location");          
  const panes = document.querySelectorAll("[data-body-location]");     
  const activate = (key) => {
    btns.forEach(b => {
      const active = b.dataset.btnLocation === key;
      b.classList.toggle('active', active);
      b.classList.toggle('text-white', active);
      b.classList.toggle('text-white/60', !active);
    });

    panes.forEach(p => {
      const show = p.dataset.bodyLocation === key;
      p.classList.toggle('hidden', !show);
      if (show) {
        p.querySelectorAll('.swiper').forEach(el => el.swiper?.update?.());
      }
    });
  };

  const initTabs = () => {
    
    const hash = (location.hash || '').replace('#','');
    const idsValidos = new Set(['ny','miami']);
    const initial =
      (idsValidos.has(hash) && hash) ||
      document.querySelector('.button-location.active')?.dataset.btnLocation ||
      panes[0]?.dataset.bodyLocation ||
      'ny';

    activate(initial);
  };

  btns.forEach(b => {
    b.addEventListener('click', (e) => {
      e.preventDefault();
      const key = b.dataset.btnLocation;
      activate(key);
    
      try { history.replaceState(null, '', `#${key}`); } catch {}
    });
  });

  initTabs();

	 const contatoFormSubmit = document.querySelector("#formulario_contact");
		const contatoFormSubmitClass = document.querySelector("#formulario_contact_class");

    contatoFormSubmit &&
        contatoFormSubmit.addEventListener("submit", function (event) {
            event.preventDefault();
            disabledBtn(contatoFormSubmit);

            const formData = {
                nome: document.querySelector("#formulario_contact input[name=nome]").value,
                email: document.querySelector("#formulario_contact input[name=email]").value,
                mensagem: document.querySelector("#formulario_contact textarea[name=mensagem]").value
            };

            console.log(formData);

            const url = "/fale-conosco/";
            axios
                .post(url, formData, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": getCookie("csrftoken"), // CSRF Token necessário no Django
                    },
                })
                .then((response) => {
										showMessage(response)
								})
                .catch((error) => showMessage(error.response || error));
        });

		contatoFormSubmitClass &&
        contatoFormSubmitClass.addEventListener("submit", function (event) {
            event.preventDefault();
            disabledBtn(contatoFormSubmitClass);

            const formData = {
                nome: document.querySelector("#formulario_contact_class input[name=nome]").value,
                email: document.querySelector("#formulario_contact_class input[name=email]").value,
                mensagem: document.querySelector("#formulario_contact_class textarea[name=mensagem]").value
            };

            console.log(formData);

            const url = "/form-inscricao/";
            axios
                .post(url, formData, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": getCookie("csrftoken"), // CSRF Token necessário no Django
                    },
                })
                .then((response) =>{
									showMessage(response)
								})
                .catch((error) => showMessage(error.response || error));
        });

    function showMessage(response) {
        const message = response.data ? response.data.message : "Erro ao enviar a mensagem";
        Toastify({
            text: message,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: "center",
            stopOnFocus: true,
            style: {
                background: "linear-gradient(to right, #00b09b, #96c93d)",
            },
        }).showToast();

        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }

    const btnSubmit = document.querySelector("#formulario_contact button[type=submit]");

    function disabledBtn(form) {
        btnSubmit.disabled = true;
        btnSubmit.classList.add("disabled");
    }

    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove("disabled");
    }

    // Função para obter o token CSRF do cookie
    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== "") {
            let cookies = document.cookie.split(";");
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i].trim();
                if (cookie.startsWith(name + "=")) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

		function changeForm() {
				const btnsForm = document.querySelectorAll('[data-cta-form]')
				const forms = document.querySelectorAll('[data-contact]')
				btnsForm.forEach(btn =>{
						btn.addEventListener('click', (e)=>{
								btnsForm.forEach(i=>{i.classList.remove('active')})
								btn.classList.add('active')
								window.dispatchEvent(new Event("resize"))
							forms.forEach(form =>{
									if (form.dataset.contact === btn.dataset.ctaForm)
										form.classList.remove('disable')
									else
										form.classList.add('disable')	
							})
						})
				})
		}

		changeForm()

const changeMaps = () =>{
	const btns = document.querySelectorAll('[data-cta-location]')
	const mapas = document.querySelectorAll('[data-content-mapa]')
	btns.forEach(btn =>{
			btn.addEventListener('click', (e)=>{
					btns.forEach(i=>{i.classList.remove('active')})
					btn.classList.add('active')
					mapas.forEach(mapa =>{
							if(mapa.dataset.contentMapa === btn.dataset.ctaLocation)
									mapa.classList.remove('disable')
							else
									mapa.classList.add('disable')								
					})
			})
	})
}

const initTabAncor = () =>{
	document.addEventListener("DOMContentLoaded", () => {
		const hash = window.location.hash;
		const flipper = document.getElementById('flipper');
		if (!flipper) return;
		if (hash === "#contact-form") {
			const target = document.querySelector(hash);
			if (target) {
				const bntClick = document.getElementById('free-class');
				if (bntClick) bntClick.click();
				flipper.classList.add('show-back');
				window.dispatchEvent(new Event("resize"));
			}
		}
	});
}

changeMaps()
initTabAncor()

document.addEventListener('DOMContentLoaded', function() {
    const btnForm = document.getElementById('contact');
    const btnInscrever = document.getElementById('free-class');
    const flipper = document.getElementById('flipper');

    // Verifica se os elementos existem
    if (btnForm && btnInscrever && flipper) {
      btnForm.addEventListener('click', () => {
        flipper.classList.remove('show-back');
        btnForm.classList.add('active');
        btnInscrever.classList.remove('active');
      });

      btnInscrever.addEventListener('click', () => {
        flipper.classList.add('show-back');
        btnInscrever.classList.add('active');
        btnForm.classList.remove('active');
      });
    }
  });
	
}